import { useQuery } from 'react-query';
import getAppContext from '@api/getAppContext';
const useAppState = () => {
    var _a, _b, _c;
    const { data, isLoading, error, isFetching } = useQuery('appContext', getAppContext, {
        suspense: true,
        staleTime: 1000 * 60 * 60 * 8, // 8 hours
    });
    return {
        paymentMethods: data === null || data === void 0 ? void 0 : data.paymentMethods,
        registrationEndingMinutes: (_a = data === null || data === void 0 ? void 0 : data.registrationEndingMinutes) !== null && _a !== void 0 ? _a : 0,
        exitWindowDuration: (_b = data === null || data === void 0 ? void 0 : data.exitWindowDuration) !== null && _b !== void 0 ? _b : 0,
        siteAlerts: (_c = data === null || data === void 0 ? void 0 : data.siteAlerts) !== null && _c !== void 0 ? _c : [],
        withdrawal: {
            minimum: 10,
            maximum: 0,
            allowCustom: true,
            allowDisclaimer: true,
            ...data === null || data === void 0 ? void 0 : data.withdrawal,
        },
        isLoading,
        isFetching,
        error: error && {
            error: error.message,
            errorCode: error.name,
        },
    };
};
export default useAppState;
